import { render } from "./index.vue?vue&type=template&id=88ddb80a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=88ddb80a&lang=less"
import "./index.vue?vue&type=style&index=1&id=88ddb80a&lang=less&scoped=true"

import exportComponent from "/Users/zllword/zongxueguan/project/verite-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ddb80a"]])

export default __exports__